export default defineNuxtRouteMiddleware((to, from) => {
  const generalStore = useGeneralStore();
  if (generalStore.isAuthenticated) {
    return navigateTo("/");
  }
});
